// Constants
import { errorLevels } from '~/App/config/errorLevels';
import { exceptionMessages } from '~/App/config/exceptionMessages';

// Helpers
import { logMessage } from '~/App/helpers/logger';

export const getPurchaseErrorMessage = (exceptionCode) => {
  if (exceptionMessages.hasOwnProperty(exceptionCode)) {
    return exceptionMessages[exceptionCode];
  } else {
    logMessage({
      level: errorLevels.info,
      message: 'Unhandled purchase exception code',
      data: { exceptionCode: exceptionCode }
    });

    return exceptionMessages.generalPaymentError;
  }
};
